import http from '@/requests/http'
import appConfig from '@/config/app'

class History {
  static all (params) {
    return http.post('messages/history/index', params)
  }
  static getByReceiverNumber (params) {
    return http.post('messages/history/get-by-receiver-number', params)
  }
  static async export (params) {
    const URLparams = new URLSearchParams(Object.entries(params))
    window.open(`${appConfig.apiBaseUrl  }/messages/history/export?${URLparams}`, '_blank')
  }
}

export default History
